export default __webpack_public_path__ + "static/media/bibliotheca.6a1ebdb4.svg";